import React, { useContext } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import apiCaller from '../interceptor'
import { catchErrMsg, erroMessage, log, requestMessage } from 'src/utils/utility';
import { AuthModel, CompanyCreation, CustomerCreation, Filter, PasswordChange, Subsidiary, User } from 'src/model';
import { useNotifier } from "react-pop-notifier"


const ApiContext = React.createContext<any>(null)

export const ApiProvider = (props: any) => {
    const {notifier} = useNotifier()
    const {info: {dashboardStats}, setInfoProperty} = useContext(AppInfoContext)
    const {loader, responder} = useContext(VisibilityContext)
   

    async function login (payload: AuthModel) {
        try {
            loader(true)
            const {data, headers} = await apiCaller.post(`users/login`, {
                ...payload
            })
            loader(false)

            console.log({headers})

            log({data}, 'login API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('token', headers.authorization)
                await setInfoProperty('userData', {...data.data})

                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getLoggedInUser () {
        try {
            loader(true)
            const {data} = await apiCaller.get(`organizations/current`)
            loader(false)

            log({data}, 'getLoggedInUser API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('organization', {...data.data})

                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function sendOtpForPasswordReset (email: string) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`users/password/reset`, {email})
            loader(false)

            log({data}, 'sendOtpForPasswordReset API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show(data.message || 'An OTP has been sent to your email', null, 'success')
                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function resetPassword (payload: any) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`users/password/reset`, payload)
            loader(false)

            log({data}, 'resetPassword API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show(data.message || 'Password Successfully Reset', null, 'success')
                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAddressStats (payload: any) {
        try {
            if (!dashboardStats?.stats) loader(true)
            const {data} = await apiCaller.get(`organizations/stats/dashboard`, {
                params: payload
            })
            loader(false)

            log({data}, 'getAddressStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, stats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getVerificationChart (year: string) {
        try {
            if (!dashboardStats?.chart) loader(true)
            const {data} = await apiCaller.get(`organizations/stats/address-verification-chart`, {
                params: {year}
            })
            loader(false)

            log({data}, 'getVerificationChart API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, chart: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getDeviceStats (payload: any) {
        try {
            if (!dashboardStats?.deviceStats) loader(true)
            const {data} = await apiCaller.get(`organizations/stats/top-devices`, {
                params: payload
            })
            loader(false)

            log({data}, 'getDeviceStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, deviceStats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getLocationStats (payload: any) {
        try {
            if (!dashboardStats?.locationStats) loader(true)
            const {data} = await apiCaller.get(`organizations/stats/top-locations`, {
                params: payload
            })
            loader(false)

            log({data}, 'getLocationStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, locationStats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getCompanyVerificationRateStats (payload: any) {
        try {
            if (!dashboardStats?.verificationRateStats) loader(true)
            const {data} = await apiCaller.get(`organizations/stats/company-verification-rate`, {
                params: payload
            })
            loader(false)

            log({data}, 'getCompanyVerificationRateStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, verificationRateStats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAdminAddressStats (payload: any) {
        try {
            if (!dashboardStats?.stats) loader(true)
            const {data} = await apiCaller.get(`admin/stats/overview`, {
                params: payload
            })
            loader(false)

            log({data}, 'getAdminAddressStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, stats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAdminVerificationChart (year: string) {
        try {
            if (!dashboardStats?.chart) loader(true)
            const {data} = await apiCaller.get(`admin/stats/address-verification-chart`, {
                params: {year}
            })
            loader(false)

            log({data}, 'getAdminVerificationChart API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, chart: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAdminDeviceStats (payload: any) {
        try {
            if (!dashboardStats?.deviceStats) loader(true)
            const {data} = await apiCaller.get(`admin/stats/top-devices`, {
                params: payload
            })
            loader(false)

            log({data}, 'getAdminDeviceStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, deviceStats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAdminLocationStats (payload: any) {
        try {
            if (!dashboardStats?.locationStats) loader(true)
            const {data} = await apiCaller.get(`admin/stats/top-locations`, {
                params: payload
            })
            loader(false)

            log({data}, 'getAdminLocationStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                await setInfoProperty('dashboardStats', {...dashboardStats, locationStats: data.data})
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getCustomers (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`organizations/customers/all`, {
                params: payload
            })
            loader(false)

            log({data}, 'getCustomers API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function verifyAddress (customerId: number) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`organizations/customers/${customerId}/verify`)
            loader(false)

            log({data}, 'verifyCustomer API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                responder.show(
                    'Address Verified Successfully', 
                    'A vitae vitae enim varius tortor suspendisse sagittis enim integer.',
                    'address-verification'
                )
                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getCustomerLocations (payload: Filter, customerId: number) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`organizations/customers/${customerId}/locations/all`, {
                params: payload
            })
            loader(false)

            log({data}, 'getCustomerLocations API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getOrganizationStaffs (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`organizations/management/staffs/all`, {
                params: payload
            })
            loader(false)

            log({data}, 'getOrganizationStaffs API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function createOrganizationStaff (payload: User) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`organizations/management/staffs/add`, {...payload})
            loader(false)

            log({data}, 'createOrganizationStaff API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show("User Successfully Created", null, 'success')
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function updateOrganizationStaff (payload: User, userId: string) {
        try {
            loader(true)
            const {data} = await apiCaller.patch(`organizations/management/staffs/update/${userId}`, {...payload})
            loader(false)

            log({data}, 'updateOrganizationStaff API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show("User Successfully Update", null, 'success')
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getOrganizationSubsidiaries (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`organizations/subsidiaries/all`, {
                params: payload
            })
            loader(false)

            log({data}, 'getOrganizationSubsidiaries API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getOrganizationSubsidiariesStats (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`organizations/subsidiaries/all/stats`, {
                params: payload
            })
            loader(false)

            log({data}, 'getOrganizationSubsidiariesStats API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function revokeStaffAccess (userId: string) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`organizations/management/staffs/revoke/${userId}`)
            loader(false)

            log({data}, 'revokeStaffAccess API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show("User Admin Access Successfully Revoked", null, 'success')
                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function addSubsidiary (formData: Subsidiary) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`organizations/subsidiaries/create`, formData)
            loader(false)

            log({data}, 'addSubsidiary API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                responder.show(
                    'Subsidiary Successfully Added', 
                    data.message || 'Creation Successful'
                )
                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function removeSubsidiary (subsidiaryId: string) {
        try {
            loader(true)
            const {data} = await apiCaller.delete(`organizations/subsidiaries/${subsidiaryId}/remove`)
            loader(false)

            log({data}, 'removeSubsidiary API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                responder.show(
                    'Subsidiary Successfully Removed', 
                    'A vitae vitae enim varius tortor suspendisse sagittis enim integer.'
                )
                return true
            }
        }
        catch (err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function changePassword (payload: PasswordChange) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`users/password/change`, payload)
            loader(false)

            log({data}, 'changePassword API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show("Password Successfully Changed", null, 'success')
                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getOrganizations (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`admin/users/organizations`, {
                params: payload
            })
            loader(false)

            log({data}, 'getOrganizations API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getSubsidiariesByOrganizationId (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`admin/users/organizations/${payload.organizationId}/subsidiaries`, {
                params: payload
            })
            loader(false)

            log({data}, 'getSubsidiariesByOrganizationId API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function suspendCompany (organizationId: string, reason: string) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`admin/users/organizations/${organizationId}/suspend`, {reason})
            loader(false)

            log({data}, 'suspendCompany API')
            
            if (!data.status) {
                responder.show(
                    'Company Suspension Failed', 
                    requestMessage(data),
                    'failure'
                )
                return false
            }
            else {
                responder.show(
                    'Company Suspension Successful', 
                    data.message || 'Suspension Successful'
                )
                return data
            }
        }
        catch (err) {
            loader(false)
            //notifier.show(erroMessage(catchErrMsg(err)))
            responder.show(
                'Company Suspension Failed', 
                erroMessage(catchErrMsg(err)),
                'failure'
            )
            return null
        }
    }

    async function unSuspendCompany (organizationId: string) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`admin/users/organizations/${organizationId}/unsuspend`)
            loader(false)

            log({data}, 'unSuspendCompany API')
            
            if (!data.status) {
                responder.show(
                    'Company Activation Failed', 
                    requestMessage(data),
                    'failure'
                )
                return false
            }
            else {
                responder.show(
                    'Company Activation Successful', 
                    data.message || 'Activation Successful'
                )
                return data
            }
        }
        catch (err) {
            loader(false)
            //notifier.show(erroMessage(catchErrMsg(err)))
            responder.show(
                'Company Activation Failed', 
                erroMessage(catchErrMsg(err)),
                'failure'
            )
            return null
        }
    }

    async function getAdminUsers (payload: Filter) {
        try {
            loader(true)
            const {data} = await apiCaller.get(`admin/users/adminusers/all`, {
                params: payload
            })
            loader(false)

            log({data}, 'getAdminUsers API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                return data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function createAdminStaff (payload: User) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`admin/users/adminusers/create`, {...payload})
            loader(false)

            log({data}, 'createAdminStaff API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show("User Successfully Created", null, 'success')
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function updateAdminStaff (payload: User, id: string) {
        try {
            loader(true)
            const {data} = await apiCaller.patch(`admin/users/${id}`, {...payload})
            loader(false)

            log({data}, 'updateAdminStaff API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                notifier.show("User Successfully Update", null, 'success')
                return data.data
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function createOrganization (payload: CompanyCreation) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`admin/users/organizations`, payload)
            loader(false)

            log({data}, 'createOrganization API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                responder.show(
                    'Company Successfully Created', 
                    data.message || 'Creation Successful'
                )

                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function createCustomer (payload: CustomerCreation) {
        try {
            loader(true)
            const {data} = await apiCaller.post(`organizations/customers/save`, payload)
            loader(false)

            log({data}, 'createCustomer API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return false
            }
            else {
                responder.show(
                    'Customer Successfully Created', 
                    data.message || 'Creation Successful'
                )

                return true
            }
        }
        catch(err) {
            loader(false)
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    const callActions = {
        login,
        getLoggedInUser,
        sendOtpForPasswordReset,
        resetPassword,
        getAddressStats,
        getVerificationChart,
        getDeviceStats,
        getLocationStats,
        getCompanyVerificationRateStats,
        verifyAddress,
        removeSubsidiary,
        suspendCompany,
        unSuspendCompany,
        getCustomers,
        getCustomerLocations,
        getOrganizationStaffs,
        createOrganizationStaff,
        updateOrganizationStaff,
        revokeStaffAccess,
        getOrganizationSubsidiaries,
        getOrganizationSubsidiariesStats,
        addSubsidiary,
        changePassword,
        getAdminAddressStats,
        getAdminVerificationChart,
        getAdminDeviceStats,
        getAdminLocationStats,
        getOrganizations,
        getSubsidiariesByOrganizationId,
        getAdminUsers,
        createAdminStaff,
        updateAdminStaff,
        createOrganization,
        createCustomer
    }

    return (
        <ApiContext.Provider value={{API: callActions}} >
            {props.children}
        </ApiContext.Provider>
    )
}

export default ApiContext